<template>
  <div class="page-container redirect-shell">
    <el-result
      icon="info"
      title="AI 配置已并入评估报告配置"
      subTitle="系统会自动带你前往新的统一配置页。"
    >
      <template slot="extra">
        <el-button type="primary" @click="goToNewPage">立即前往</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  name: 'AIReportConfig',
  created() {
    this.goToNewPage()
  },
  methods: {
    goToNewPage() {
      const taskId = this.$route.params.taskId
      const path = taskId ? `/admin/tasks/${taskId}/contents` : '/admin/contents'
      this.$router.replace({ path, query: { tab: 'ai' } })
    }
  }
}
</script>

<style scoped>
.redirect-shell {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
